import clsx from 'clsx';
import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import iconLike from "../../assets/images/like-icon.png";
import { Changeselectetedtab, Changetab, Changetab2 } from '../../redux/actions/design';



const BonusPopover = React.forwardRef(
  ({ popper, children, show: _,...props }, ref) => {
    const { selectedBMmalus ,selectedBMmalus1,selectedBMselectedmalus1} = useSelector((state) => state.design);
    const dispatch=useDispatch()
    useEffect(() => {
      
      popper.scheduleUpdate();
    }, [children, popper,dispatch]);
    function isObjEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
    
      return true;
    }
    
    const  addBonus = (item) => {
      
     
      
      if(isObjEmpty(selectedBMselectedmalus1)|| !(Object.keys(selectedBMselectedmalus1)[0]===props.gc.id)){ 
        if(selectedBMselectedmalus1[props.gc.id]){
           if(!( Object?.values(selectedBMmalus)?.filter(
            (element) => element?.id === item.id
            ).length > 0))
         
          selectedBMselectedmalus1[props.gc.id]+=item.score
          else{
       selectedBMselectedmalus1[props.gc.id]=selectedBMselectedmalus1[props.gc.id]-item.score
      dispatch(Changeselectetedtab(selectedBMselectedmalus1))
          }
        }
        else{
         
          selectedBMselectedmalus1[props.gc.id]=item.score
        }
        
        
     dispatch(Changeselectetedtab((selectedBMselectedmalus1)))}
     else{
      delete selectedBMselectedmalus1[props.gc.id]
      dispatch(Changeselectetedtab(selectedBMselectedmalus1)) 
      
     }
      if(!isObjEmpty(item)){ 
         dispatch(Changetab([...selectedBMmalus,{ id: item.id, BM: item.score }])) 
          if( !selectedBMmalus1.includes(item.score)){
        dispatch(Changetab2([...selectedBMmalus1,  item.score ]))
       
      }
      else{
        
        const index = selectedBMmalus1.indexOf(item.score);
        if (index > -1) {
          selectedBMmalus1.splice(index, 1); // 2nd parameter means remove one item only
        }

      }
          selectedBMmalus.forEach((element) => {
        if (element.id === item.id) {
          dispatch(Changetab(
            selectedBMmalus.filter((element) => element?.id !== item.id)
          ));
        
        }
        
      });
      }
      
     

    
    
    };
    
    return (
      <Popover ref={ref} body  {...props} >
        {children.map((item, i) => (
          
          <div
            key={i}
            onClick={() => addBonus(item)}
            className={clsx("container-bonus-malus-eval", {
              "container-bonus-malus-on":
                Object?.values(selectedBMmalus)?.filter(
                  (element) => element?.id === item.id
                ).length > 0,
              "container-bonus-malus-off":
                Object?.values(selectedBMmalus)?.filter(
                  (element) => element?.id === item.id
                ).length === 0 && item.id === null,
            })}
            
          >
       
            {item.name}
            <div
              className={clsx({
                "icon-bonus-malus-on":
                  Object.values(selectedBMmalus)?.filter(
                    (element) => element?.id === item.id
                  ).length > 0,
                "icon-bonus-malus-off":
                  Object.values(selectedBMmalus)?.filter(
                    (element) => element?.id === item.id
                  ).length === 0 || item.id === null,
              })}
            ></div>
          </div>
        ))}
      </Popover>
    );
  }
);

const Popover1 = (props) => {


    return (
        <OverlayTrigger
                          
        trigger={"click"}
        rootClose
        placement="bottom-end"
        overlay={
          <BonusPopover
            id="popover-contained"
            className="popup-like-dislike"
            gc={props.gc}
            ic={props.ic}
            c={props.c}
          >
        {props.handelbonu(props.gc.id).name[props.ic]&&props.handelbonu(props.gc.id).name[props.ic].map(e=>(e)).filter(e=>(e.name==="Bonus"))[0]?.CriteriaOptionValue?props.handelbonu(props.gc.id).name[props.ic].map(e=>(e)).filter(e=>(e.name==="Bonus"))[0]?.CriteriaOptionValue:[{}]}
          </BonusPopover>
        }
      >
        <img
          className="img-chat-position"
          width={20}
          src={iconLike}
        />
      </OverlayTrigger>    )
}

export default Popover1